/* eslint-disable jsx-a11y/control-has-associated-label */
import { useNavigate, useLocation } from "react-router-dom";
import classNames from "classnames";
import UserControlsNotAuth from "components/molecules/UserControlsNotAuth";
import UserControlsAuth from "components/molecules/UserControlsAuth";
import BangerSupportIcon from "assets/icons/banger/support.svg?react";
import ArrowDropdownIcon from "assets/icons/glory/arrow_dropdown.svg?react";
import CountrySelectContainer from "containers/molecules/CountrySelectContainer";
import NotificationCircle from "components/atoms/NotificationCircle";
import useTranslate from "hooks/useTranslate";
import KingIcon from "assets/icons/loyalty/king.svg?react";
import { makeLangUrl } from "helpers/makeLangUrl";
import url from "url/index";
import { useGTM } from "hooks/useGTM";
import { useNotificationUserBonuses } from "hooks/useNotificationUserBonuses";
import { useLoyaltyStore } from "stores/loyalty";
import { useBreakpoint } from "hooks/useBreakpoint";
import { GET_POPUP_TYPES } from "constants/popupConfig";
import "./styles.sass";

type UserInfoType = {
  balance: number;
  bonus: number;
  isAuthenticated: boolean | null;
  isCountriesOpen: boolean;
  chatWootInit: () => void;
  hasLoyalty?: boolean;
  avatar?: string;
};

const UserInfo = ({
  balance,
  bonus,
  isAuthenticated,
  isCountriesOpen,
  chatWootInit,
  hasLoyalty,
  avatar,
}: UserInfoType) => {
  const t = useTranslate();
  const GTM = useGTM();
  const navigate = useNavigate();
  const { isActive: notifyBonusesActive } = useNotificationUserBonuses();
  const location = useLocation();
  const { isCustomBreakpointSmaller, isDesktop } = useBreakpoint(440);
  const isLoyaltyPage = location.pathname.endsWith("profile/loyalty/");
  const handleOpenOnboarding = useLoyaltyStore(
    (state) => state.setIsOpenOnboarding,
  );

  const handleChatWootInit = () => {
    chatWootInit();
  };

  const handleGoToProfile = () => {
    GTM.clickProfilePage();
    navigate(makeLangUrl(url.routes.profile.index()));
  };

  const handleGoToLoyalty = () => {
    if (isDesktop) {
      navigate(makeLangUrl(url.routes.profile.loyaltyProgram()));
    } else {
      handleGoToProfile();
    }
  };

  const handleOpenLoyaltyOnboarding = () => {
    if (isCustomBreakpointSmaller) {
      navigate(
        `${location.pathname}?popup=${GET_POPUP_TYPES.popup.loyaltyOnboarding}`,
        { replace: true },
      );
    } else {
      handleOpenOnboarding(true);
    }
  };

  const classNameButton = classNames("UserInfo__profile", {
    isSettings: !avatar,
    isLoyaltyAvatar: hasLoyalty,
  });

  const handleClickAvatar = () => {
    if (hasLoyalty && isLoyaltyPage) {
      handleOpenLoyaltyOnboarding();
    } else if (hasLoyalty) {
      handleGoToLoyalty();
    } else {
      handleGoToProfile();
    }
  };

  return (
    <div className="UserInfo">
      {isAuthenticated ? (
        <div>
          <UserControlsAuth bonus={bonus} balance={balance} />
        </div>
      ) : (
        <div className="UserInfo__controls">
          <UserControlsNotAuth />
        </div>
      )}
      <div className="UserInfo__support">
        <button
          type="button"
          className="UserInfo__chatwoot"
          onClick={handleChatWootInit}
        >
          <BangerSupportIcon />
        </button>
        {isCountriesOpen && (
          <div className="UserInfo__countries">
            <div className="UserInfo__countries_arrow">
              <ArrowDropdownIcon />
            </div>
            <div className="UserInfo__countries_title">
              {t("casino.countries.select")}
            </div>
            <div className="UserInfo__countries_list">
              <CountrySelectContainer />
            </div>
          </div>
        )}
      </div>
      <button
        id="header-user-avatar"
        type="button"
        className={classNameButton}
        // eslint-disable-next-line react/jsx-handler-names
        onClick={handleClickAvatar}
      >
        {notifyBonusesActive ? (
          <NotificationCircle className="UserInfo__btnNotify" />
        ) : null}
        {!!avatar && hasLoyalty ? (
          <div className="UserInfo__profile_avatar">
            <img src={avatar} alt="profile" />
          </div>
        ) : (
          <KingIcon />
        )}
      </button>
    </div>
  );
};

export default UserInfo;
